// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsBroadcast = {
    "aws_appsync_graphqlEndpoint": "https://dthi4vdmcjalzkv4aahrcyfh74.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-4mfcosyvs5fsnls6rmxg2ur6vu",
};

export default awsBroadcast;